module.exports = __webpack_public_path__ + "static/img/7.4b6c47b1.png";